export const TeamMemberStatus = Object.freeze({
  pending: 0,
  accepted: 1,
  rejected: 2,
  active: 3,
  deactivated: 4,
});

export const TeamMemberStatusLabel = Object.freeze({
  [TeamMemberStatus.pending]: 'Invited',
  [TeamMemberStatus.accepted]: 'Accepted',
  [TeamMemberStatus.rejected]: 'Rejected',
  [TeamMemberStatus.active]: 'Active',
  [TeamMemberStatus.deactivated]: 'Deactivated',
});

export const getStatusOrder = (status) =>
  [
    TeamMemberStatus.active,
    TeamMemberStatus.deactivated,
    TeamMemberStatus.pending,
    TeamMemberStatus.rejected,
  ].indexOf(status);
